/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { Injectable } from '@angular/core';
import { NotificationUserModel } from '@app/models/notification-user.model';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class NotificationUserListService extends ApiBaseService {
  private _notificationUsersList: NotificationUserModel[] = [];
  protected _endpoint = 'notification_users';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get notificationUsersList(): NotificationUserModel[] {
    return this._notificationUsersList;
  }

  set notificationUsersList(value: NotificationUserModel[]) {
    this._notificationUsersList = value;
  }

  /**
   *  Warren Dowey & Ryan Duffy
   *
   *  getNotificationUserByNotificationId
   *
   * : Get an notification based on the id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the notification with the id that meets the query
   */
  getNotificationUserById(notificationId: string, userId: string): NotificationUserModel {
    for (const notification of this.notificationUsersList) {
      if (notification.notificationId === notificationId && notification.userId === userId) {
        return notification;
      }
    }
  }

  /**
   *  Warren Dowey & Ryan Duffy
   *
   *  getNotificationUserByUserId
   *
   * : Get an notification user based on the id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the user with the id that meets the query
   */
  getNotificationUserByUserId(userId: string): NotificationUserModel {
    for (const notification of this.notificationUsersList) {
      if (notification.userId[0] === userId) {
        return notification;
      }
    }
    return null;
  }

  /**
   *   Warren Dowey & Ryan Duffy
   *
   *  addtoList
   *
   * : handles the insert of a new notificationUser into the list
   *
   * @param data of type NotificationUserModel
   *
   * @returns Void: inserts a new notificationUser into the lsit
   */
  addToList(data: NotificationUserModel): void {
    this.notificationUsersList.push(data);
  }
  /**
   *   Warren Dowey & Ryan Duffy
   *
   *  removeFromList
   *
   * : deletes an notificationUser from the list
   *
   * @param data of type NotificationUserModel
   *
   * @returns Void: deletes a notificationUser
   */
  removeFromList(data: NotificationUserModel): void {
    let index = 0;
    for (const notificationUser of this.notificationUsersList) {
      if (notificationUser.notificationId === data.notificationId) {
        this.notificationUsersList.slice(index, 1);
      }
      index++;
    }
  }
  /**
   *  Warren Dowey
   *
   *  updateInList
   *
   * : handles the update of an notificationUser in the list
   *
   * @param data of type notificationUsermodel
   *
   * @returns Void: update the list with the data
   */
  updateInList(data: NotificationUserModel): void {
    for (let notificationUser of this.notificationUsersList) {
      if (notificationUser.notificationId === data.notificationId) {
        notificationUser = data;
      }
    }
  }
  /**
   *  Warren Dowey
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type NotificationUserModel
   *
   * @returns Void: get the notificationUser from the postgres database and create the list
   */
  protected handleData(data: any): void {
    this.notificationUsersList = [];
    let notificationUser: NotificationUserModel;
    super.handleData(data);
    for (const item of data) {
      notificationUser = new NotificationUserModel();
      this.addToList(notificationUser.fromJson(item));
    }
  }
}
